import { Input } from "components/ui/input";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "components/ui/select";
import { RANGE_FILTER } from "constants/Constants";

const rangeTypes = [
  {
    symbol: "≥",
    text: "Greater or equal to",
    value: RANGE_FILTER.GREATER_THAN,
  },
  {
    symbol: "≤",
    text: "Less or equal to",
    value: RANGE_FILTER.LESS_THAN,
  },
  {
    symbol: "↔",
    text: "Between",
    value: RANGE_FILTER.BETWEEN,
  },
];

const initialValue = {
  op: RANGE_FILTER.GREATER_THAN,
  value: [],
};

export function RangeFilter({ value, onChange }) {
  const current = value ?? initialValue;
  const bounds = current.value ?? [];
  const isBetween = current.op === RANGE_FILTER.BETWEEN;

  const handleChangeOp = op =>
    onChange({
      op,
      value: op === RANGE_FILTER.BETWEEN ? bounds : bounds.slice(0, 1),
    });

  const handleChangeBound = (index, next) => {
    const updated = [...bounds];
    updated[index] = next;
    onChange({ ...current, value: updated });
  };

  return (
    <div className="tw:flex tw:items-center tw:gap-4">
      <Select value={current.op} onValueChange={handleChangeOp}>
        <SelectTrigger
          aria-label="Comparison operator"
          className="tw:w-16 tw:bg-white tw:dark:bg-background"
        >
          <SelectValue placeholder="Op">
            {op => rangeTypes.find(range => range.value === op)?.symbol}
          </SelectValue>
        </SelectTrigger>
        <SelectContent alignItemWithTrigger={false} className="tw:w-52">
          <SelectGroup>
            {rangeTypes.map(range => (
              <SelectItem key={range.value} value={range.value}>
                <span className="tw:inline-block tw:w-5 tw:text-center tw:font-medium">
                  {range.symbol}
                </span>
                {range.text}
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
      <Input
        type="number"
        value={bounds[0] ?? ""}
        onChange={e => handleChangeBound(0, e.target.value)}
        className="tw:bg-white tw:dark:bg-background tw:w-full tw:max-w-24"
        placeholder={isBetween ? "From" : "Ex: 10"}
      />
      {isBetween && (
        <Input
          type="number"
          value={bounds[1] ?? ""}
          onChange={e => handleChangeBound(1, e.target.value)}
          className="tw:bg-white tw:dark:bg-background tw:w-full tw:max-w-24"
          placeholder="To"
        />
      )}
    </div>
  );
}
